import { gql } from '@apollo/client';

export const INTEGRATION_META_CARRIER_PRICING_OVERRIDES_FIELDS = gql`
    fragment IntegrationMetaCarrierPricingOverridesFields on integration_meta_carrier_pricing_overrides {
        add_margin_flat
        add_margin_rate
        algo_type
        client_id
        created_at
        integration_carrier_pricing_override_id
        integration_type_id
        last_modified_at
        override_type
        pricing_parameters
        tariff_id
        zip_geofence
    }
`;
